const getters = {
  checkForUGCComponent(store) {
    return ({ componentName }) => {
      const recipeComponent = store.recipe_v2.components && store.recipe_v2.components[componentName];
      return !!(recipeComponent && recipeComponent.ugc);
    };
  },
  checkComponentExists(store) {
    return ({ componentName }) => {
      return componentName && store.recipe_v2.components[componentName];
    }
  },
  getSwatchIdFromComponent(store){
    return ({componentName}) => { return store.recipe_v2.components[componentName].swatch_id;}
  },
  getImageLibComponentsName(store) {
    const comps = store.recipe_v2.components;
    return Object.keys(comps).filter(name => comps[name].subgroup === "library" && comps[name].hasOwnProperty('ugc'));
  }
};

export default getters;
